import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            剧集更新、平台公告、追剧快讯，第一时间掌握被窝影院最新动向
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300/60"></div>

            <div className="space-y-1">
              {updateItems.map((item) => (
                <div key={item.id} className="relative pl-10 md:pl-12 py-4 group cursor-pointer">
                  <div className="absolute left-2.5 md:left-3.5 top-5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 group-hover:scale-125 transition-transform"></div>

                  <div className="flex items-start gap-3 flex-wrap">
                    <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>

                  <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}